
import React from 'react';
import GoogleReviews from "@/components/EnquiryContainer/GoogleReviews";

const EnquiryTestimonialsSection = ({ data }) => {
    if (!data) return null;
    const { title, subtitle, statText, googleReviewsLink } = data;

    return (
        <section className="px-6 py-12 bg-white">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-[#8A1C23] mb-4">{title}</h2>
                    <p className="text-lg text-gray-600">
                        {subtitle}
                    </p>
                </div>

                <div className="overflow-x-auto flex gap-4 snap-x scroll-smooth pb-4">
                    <GoogleReviews  reviews = {data?.reviews}/>
                </div>

                <div className="text-center mt-8">
                    <p className="text-gray-600 text-sm">
                        Join thousands of blessed families •
                        <span className="text-yellow-700 font-semibold"> {statText}</span>
                    </p>
                </div>
                <div className="text-center mt-8">
                    <p className="text-gray-600 text-sm">
                        Check all of our{" "}
                        <a
                            href={googleReviewsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=" font-semibold underline hover:text-[#8A1C23]"
                        >
                            Google Reviews
                        </a>
                    </p>
                </div>

            </div>
        </section>
    );
};

export default EnquiryTestimonialsSection;